import React from 'react';
import { ArrowRight, Clock, Heart } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 px-4 bg-[#EEF2F7]" data-id="element-330">
      <div className="max-w-[700px] mx-auto" data-id="element-331">
        <div className="text-center mb-10" data-id="element-332">
          <h2 className="text-2xl font-bold text-[#B83A52] mb-4 uppercase tracking-tight flex items-center justify-center gap-2" data-id="element-333">
            <Clock className="w-6 h-6" data-id="element-334" /> El tiempo es el recurso más escaso
          </h2>
          <p className="text-[#4A4A6A] mb-6 max-w-lg mx-auto" data-id="element-335">
            Cada día que pasas sin un plan es un día de apoyo improvisado. Cada
            visita sin saber qué decir es una oportunidad perdida de conexión
            real.
          </p>
        </div>

        <h3 className="text-center text-[#1C1C2E] font-serif font-bold text-2xl mb-8" data-id="element-336">
          Hay dos tipos de familias
        </h3>

        <div className="grid grid-cols-1 gap-6 mb-10" data-id="element-337">
          {/* Path A */}
          <div className="bg-white border border-[#E2E8F0] rounded-xl p-6 opacity-80" data-id="element-338">
            <div className="flex items-center gap-3 mb-4 border-b border-[#E2E8F0] pb-3" data-id="element-339">
              <div className="w-8 h-8 rounded-full bg-[#F3F4F6] flex items-center justify-center font-bold text-[#4A4A6A]" data-id="element-340">
                A
              </div>
              <h4 className="text-[#4A4A6A] font-bold text-lg" data-id="element-341">
                Las que improvisan
              </h4>
            </div>
            <p className="text-[#4A4A6A] text-sm" data-id="element-342">
              Se agotan, se sienten culpables, discuten entre ellos y con el
              tiempo miran atrás preguntándose: "¿Hice suficiente?".
            </p>
          </div>

          {/* Path B */}
          <div className="bg-white border-2 border-[#1B3A6B] rounded-xl p-6 shadow-navy-medium transform scale-[1.02]" data-id="element-343">
            <div className="flex items-center gap-3 mb-4 border-b border-[#1B3A6B]/20 pb-3" data-id="element-344">
              <div className="w-8 h-8 rounded-full bg-[#1B3A6B] flex items-center justify-center font-bold text-white" data-id="element-345">
                B
              </div>
              <h4 className="text-[#1B3A6B] font-bold text-lg" data-id="element-346">
                Las que tienen un sistema
              </h4>
            </div>
            <p className="text-[#1C1C2E] font-medium text-sm" data-id="element-347">
              Las que al final, sin importar el resultado médico, pueden decir
              con toda certeza: "Estuve ahí. Supe cómo estar. Fui suficiente."
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-348">
          <a href="#comprar" className="inline-flex items-center gap-2 bg-[#1B3A6B] text-white font-bold py-4 px-8 rounded-full hover:bg-[#2D4F85] transition-colors shadow-lg" data-id="element-349">
            Quiero ser la Familia B <ArrowRight className="w-4 h-4" data-id="element-350" />
          </a>
        </div>
      </div>
    </section>;
}